// @flow

import React, { Component } from 'react'
import { containerIds } from 'redux/modules/ui'
import { getAddressFromPostalCode } from 'frontend_core/dist/helpers/places'

export type UserContactModalUseCaseType = {
  initialize: Function,
  closeModal: Function,
  handleChangeUIField: Function,
  handleChangeUIContactField: Function,
  sendSms: Function,
  makeCall: Function,
  verifyCode: Function,
  backToPhoneNumber: Function,
  toInquiry: Function,
}

export default (WrappedComponent: any) =>
  class RoomUseCase extends Component<*> {
    convertRemoteContactToUIContact = (contact: any) => ({
      id: contact.id,
      familyName: contact.family_name,
      givenName: contact.given_name,
      corpName: contact.corp_name,
      department: contact.department,
      phone: (contact.phone || {}).tel || contact.tel,
    })

    /**
     * 初期処理
     */
    initialize = () => {
      const { actions, currentUser } = this.props
      actions.fetchLargeAreas()

      const onUserFetched = user => {
        const { contact } = user
        const isAlreadySavedContact =
          contact &&
          typeof contact.family_name === 'string' &&
          typeof contact.given_name === 'string'
        const isOpenInquiry = user.has_confirmed_phone && isAlreadySavedContact
        actions.setUIState(containerIds.ROOM, {
          isOpenInquiry,
          isOpenUserContact: !isOpenInquiry,
          hasConfirmedPhone: user.has_confirmed_phone,
          isAlreadySavedContact,
          contact: this.convertRemoteContactToUIContact(contact || {}),
        })
      }

      actions.fetchUser({
        userId: currentUser.id,
        fetched: onUserFetched,
      })
    }

    /**
     * モーダルを閉じる
     */
    closeModal = (e: Event) => {
      e.preventDefault()
      const { actions } = this.props
      actions.setUIState(containerIds.ROOM, { isOpenUserContact: false })
    }

    /**
     * contactのUIフィールドを変更
     */
    handleChangeUIContactField = (
      e: SyntheticInputEvent<*>,
      propName: string,
    ) => {
      e.preventDefault()
      const { ui, actions } = this.props
      const uiContact = ui.contact || {}
      uiContact[propName] = e.target.value
      actions.setUIState(containerIds.ROOM, { contact: uiContact })
    }

    /**
     * UIフィールドを変更
     */
    handleChangeUIField = (e: SyntheticInputEvent<*>, propName: string) => {
      e.preventDefault()
      const { actions, ui } = this.props
      ui[propName] = e.target.value
      actions.setUIState(containerIds.ROOM, ui)
    }

    /**
     * 電話番号認証 - SMSを送信する
     */
    sendSms = (e: SyntheticInputEvent<*>) => {
      e.preventDefault()
      const { user, ui, actions } = this.props
      actions.verifyPhoneSms({
        userId: user.user.id,
        phoneNumber: ui.phoneNumber,
      })
    }

    /**
     * 電話番号認証 - 電話をかける
     */
    makeCall = (e: SyntheticInputEvent<*>) => {
      e.preventDefault()
      const { user, ui, actions } = this.props
      actions.verifyPhoneCall({
        userId: user.user.id,
        phoneNumber: ui.phoneNumber,
      })
    }

    /**
     * 認証コードを送信
     */
    verifyCode = (e: SyntheticInputEvent<*>) => {
      e.preventDefault()
      const { user, ui, actions } = this.props
      actions.confirmVerifyCode({
        userId: user.user.id,
        code: ui.verifyCode,
      })
    }

    /**
     * 認証コードを送信せずに、電話番号入力へ戻る
     */
    backToPhoneNumber = (e: SyntheticInputEvent<*>) => {
      e.preventDefault()
      const { actions } = this.props
      actions.setUIState(containerIds.ROOM, {
        phoneNumber: '',
        sentPhoneNumber: '',
        verifyCode: '',
      })
    }

    /**
     * お問い合わせ送信モーダルを表示
     */
    toInquiry = (e: SyntheticInputEvent<*>) => {
      e.preventDefault()
      const { actions, ui } = this.props

      if (ui.isAlreadySavedContact) {
        actions.setUIState(containerIds.ROOM, {
          isOpenInquiry: true,
          isOpenUserContact: false,
        })
      } else {
        actions.updateUser({
          onSuccess: () => {
            actions.setUIState(containerIds.ROOM, {
              isOpenInquiry: true,
              isOpenUserContact: false,
            })
          },
        })
      }
    }

    render() {
      return <WrappedComponent {...this.props} usecase={this} />
    }
  }



// WEBPACK FOOTER //
// ./src/containers/organisms/UserContactModal/usecase.jsx